/* eslint-disable react/prop-types */
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import Scrollbar from '../scrollbar/Scrollbar';

function CardSecundario({ nota, createdAt }) {
  return (
    <>
      <Card variant="outlined" sx={{ m: 1 }}>
        <CardContent>{nota}</CardContent>
      </Card>
      <Typography component="legend" sx={{ fontSize: 12, marginLeft: 2, color: '#CCCCCC' }}>
        {moment(createdAt).format('ll')}
      </Typography>
    </>
  );
}

export function ListaNotasCredito() {
  const credito = useSelector((state) => state?.creditosActivos?.creditoEditable);

  return (
    <Grid item xs={12} md={8} lg={8}>
      <Card sx={{ height: '424px' }}>
        <Scrollbar>
          <CardHeader
            title={'Notas del crédito'}
            subheader={`Historial de observaciones del credito C${credito?.id}.--`}
          />
          {credito?.NotasCredito?.length === 0 ? (
            <CardContent>
              <Typography component="legend" sx={{ display: 'flex', margin: 3, color: '#CCCCCC' }}>
                No hay observaciones del Crédito.
              </Typography>
            </CardContent>
          ) : (
            credito?.NotasCredito?.map((nota) => (
              <CardContent key={nota.createdAt}>
                <CardSecundario {...nota} />
              </CardContent>
            ))
          )}
        </Scrollbar>
      </Card>
    </Grid>
  );
}
